module.exports = __webpack_public_path__ + "static/media/narrative_completed.72da4aac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/narratives/narrative_completed.svg
// module id = 1850
// module chunks = 0